import React from 'react';
import {NavLink} from 'react-router-dom'

import imgCaptn from '../../images/Captn.png'
import imgN3RD from '../../images/N3RD.png'
import imgSniper from '../../images/Sniper.png'
import imgDr from '../../images/Dr.png'
import imgTheShip from '../../images/TheShipB.gif'
import imgShipPlan from '../../images/Obsidian Isurus.png'
import imgT1 from '../../images/T1.gif'
const Soon = (props)=>{
 
  return(
  <div className='mypage fluid-container p-3'> 
  <h2>Coming Soon</h2>
    
  <div className="row justify-content-center">
  <div className="col-8"><h2>Void Cheddar's Dirty 1/3 Dozen</h2></div><div className="col-8"> 
  {(!props.data.usr)?(<div><NavLink to='./login'>Login to check on upcoming alpha...</NavLink>  or... <NavLink to='./register'>Register if your new !!!</NavLink></div>):''}
  </div></div>
  <div className="row justify-content-center">
  <div className="col-12" Style="font-size: 1.8em">
  <img alt="splashani" className="myport img-thumbnail" Style="float:left;" src={imgT1} /> 
     <p>A band of four merry spacer ne'er-do-wells have landed themselves in a very unsavory position.</p>
     <p>One night during a K-raa-zy pizza party, they underestimated the cost of space pepporoni, thus, placing them
     deep in debt to Void Cheddar, the universally feared interstellar pizza gang boss.</p>
     <p>Their only slim chance at survival, now lays in fulfilling every, insane, cheese filled, whim of their gangster overlord.</p>
     <p>This game will feature RPG classes, turned based gaming,  characters and situations you have never seen before, in dubious plots, with suspicious undertones... not to mention it's super duper pre pre pre alpha... you have been warned. (There is no mercy in Void Cheedar's service...)</p>
     
     </div>

    
    </div>
   

  <div className="row">
  <div className="col-12">
    <h3>Meet The Crew</h3>
    <div className="row">
    <div className="col-6 col-md-3">
    <h6>The Captain</h6>
    
    <img className="myport img-thumbnail img-fluid" src={imgCaptn} alt="thecaptn"/>
    <p>Hardened Bounty Hunter Shera Steel, Captains the Obsidian Isurus and leads the Dirty 1/3 in both space and ground battles. She is as hard as steel and could easily take a deathstar shot to the face. With one sharp quip, she has been known to have the most fearsome space pirate murderer, crying for his mommy. DO NOT MESS with Captain Steel.</p>
    </div>
    <div className="col-6 col-md-3">
    <h6>N3RD</h6>
    
    <img className="myport img-thumbnail img-fluid" src={imgN3RD} alt="thecaptn"/>
    <p>Super Meta Ultra Nano Scientist Johnny Alive became one of his own failed experiments in his early teens. While a youth he managed to transfer his consciousness to a robot, after a particularly embarrassing prom night, which he still refuses to talk about. An expert in all things technical Johnny handles the tech for the crew.</p>
    </div>
    <div className="col-6 col-md-3">
    <h6>The Sniper</h6>
    
    <img className="myport img-thumbnail img-fluid" src={imgSniper} alt="thecaptn"/>
    <p>Miss Amanda Darkshot, the crews damage specialist, was raised on the planet HideyBush, which is home to her species an entire planet of sentient fir trees. Oddly, Amanda prefers to spend most of her time disguise as an earth guerilla sniper. Her natural tree form however provides tons of advantages to her and her crew, not to mention the amount of damage she does with that shoulder cannon.</p>
    </div>
    <div className="col-6 col-md-3">
    <h6>The Doc</h6>
    
    <img className="myport img-thumbnail img-fluid" src={imgDr} alt="thecaptn"/>
    <p>Doc McHeals, was born on earth and lived a mostly normal life, outside of his work on advanced and deadly biological weapons and resurrection, he's just your normal run of the mill space doctor warrior...</p>
    </div>
    
  
    </div>
    
    </div>
    
  
    </div>
    <div className="col-12 col-md-12">
    <h3>The Ship</h3>
    <p>This ancient ship is as ruthless a survivor and killer as any that have set foot upon her can lay claim to be. Mercilessly complex to fly, impossible to escape, and armed with an arcane and overwhelmingly powerful weapon and drive capability, that is as unstable as it is powerful, she is as much a mortal danger to her own crew as she is their passion.</p>
    <div className='row'>
    <div className='col-6'><img className="img-fluid" src={imgShipPlan} alt="thecaptn"/></div>
    <div className='col-6'><img className="img-fluid" src={imgTheShip} alt="thecaptn"/></div>
    
    </div>
    
    </div>
  </div>  
  
  

    
    
  )};
  
export default Soon;  


// WEBPACK FOOTER //
// ./src/container/Pages/Soon.js